import { z } from 'zod';
import { OffsetPaginationParamsSchema } from '../offset-pagination.js';
// ---------------------------------------------------------------------------
// Sponsor / CRO dictionaries (tenant_admin-only create, 409 on duplicate)
// ---------------------------------------------------------------------------
export const SponsorDtoSchema = z.object({
    id: z.number().int().positive(),
    tenantId: z.number().int().positive(),
    name: z.string().min(1).max(255),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const CroDtoSchema = SponsorDtoSchema;
export const CreateSponsorRequestSchema = z.object({
    name: z.string().min(1, 'Nazwa sponsora jest wymagana').max(255),
});
export const CreateCroRequestSchema = z.object({
    name: z.string().min(1, 'Nazwa CRO jest wymagana').max(255),
});
export const SponsorListQuerySchema = OffsetPaginationParamsSchema.extend({
    search: z.string().max(100).optional(),
});
export const CroListQuerySchema = OffsetPaginationParamsSchema.extend({
    search: z.string().max(100).optional(),
});
//# sourceMappingURL=dictionaries.schema.js.map